module.exports = require("stream");


//////////////////
// WEBPACK FOOTER
// external "stream"
// module id = 77
// module chunks = 0